export enum PROPERTIES_TABS {
  USER_PROPERTIES,
  USER_FAVORITE_PROPERTIES,
}
